module.exports = __webpack_public_path__ + "img/DE01562.ab6476d3.png";